import React from "react";
//import PropTypes from "prop-types";
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";
import { getAdminUsers } from '../../actions/user'

// material-ui components
import withStyles from "material-ui/styles/withStyles";

// core components
import IconCard from "components/Cards/IconCard.jsx";
import RequirementsCard from "components/Cards/RequirementsCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import Table from "components/Table/Table.jsx";
import Button from "components/CustomButtons/Button.jsx";

// material-ui icons
import Assignment from "@material-ui/icons/Assignment";
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Done from "@material-ui/icons/Done";
import AttachMoney from "@material-ui/icons/AttachMoney";

import locationsPageStyle from "assets/jss/material-dashboard-pro-react/views/locationsPageStyle.jsx";


class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
    };
  }

  handleTableAction(action, id){
    if(action==="delete"){
    }  
    if(action==="edit"){
    }
  }

  componentDidMount() {
    this.props.dispatchGetAdminUsers(this.props.auth.user)
    .then( users => {
      this.setState({users});
    });   
  }
  render() {
    const {  translate, classes } = this.props;

    var tableData = [];
    if(this.state.users.length>0){
      this.state.users.map((prop,key)=>{
        
        let fillButtons = [
          { color: "info", icon: Person, action:"view" },
          { color: "success", icon: Edit, action: "edit" },
          { color: "success", icon: AttachMoney, action: "edit" },
          { color: "danger", icon: Close, action: "delete" }
        ].map((button, buttonKey) => {
          return (
            <Button color={button.color} customClass={classes.actionButton} onClick={() => this.handleTableAction(button.action, prop.id)} key={buttonKey}>
              <button.icon className={classes.icon} />
            </Button>
          );
        });

        let roles = JSON.parse(prop.roles);
        let admin = roles["admin"]?<Done />:"";
        let dev = roles["dev"]?<Done />:"";
        let customer = roles["customer"]?<Done />:"";
        let receiver = roles["receiver"]?<Done />:"";

        tableData.push([ prop.username, admin, dev, customer, receiver, fillButtons]);

        return false;
      });
    }

    return (
      <div>
        <GridContainer>
          {this.state.alert}        
          <ItemGrid xs={12} sm={12} md={6}>
            <RequirementsCard content={translate("requirements.admin_users.content")} /> 
          </ItemGrid>                
          <ItemGrid xs={12} sm={12} md={12}>
            <IconCard
              icon={Assignment}
              iconColor="rose"
              title="Users"
              content={
                <Table
                  tableHead={[
                    "Username",
                    "Admin",
                    "Dev",
                    "Customer",
                    "Receiver",
                    "Actions"
                  ]}
                  tableData={tableData}
                />
              }
            />
          </ItemGrid>                    
        </GridContainer>
      </div>
    );
  }
}


const mapDispatchToProps = {
  dispatchGetAdminUsers: (user) => getAdminUsers(user),
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
  }
}


export default compose(
  withStyles(locationsPageStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(Users);



// WEBPACK FOOTER //
// ./src/views/Admin/Users.jsx